import React, { useMemo } from "react"
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import DataGridColumnGenerator, { AddStatusColumnData } from "components/Common/DataGridColumnGenerator";
import useIsMobile from "helpers/hooks/useIsMobile";
import { Grid, Typography, useTheme } from "@mui/material";
import { useTranslations } from "@fenetech/translations";
import useDashboardSubmittedQuoteData from "./useDashboardSubmittedQuoteData";
import useCurrencyFormatter from "helpers/hooks/useCurrencyFormatter";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

interface IProps {

}

const SubmittedQuotesGrid: React.FC<IProps> = (props: IProps) => {

    const tm = useTranslations();
    const theme = useTheme();
    const cf = useCurrencyFormatter();
    const rawData = useDashboardSubmittedQuoteData();
    const isMobile = useIsMobile();

    const getRowId: GridRowIdGetter = (row: GridRowModel) => {
        return row.oKey;
    }

    const data = React.useMemo(() => {
        if (rawData) {
            return rawData.map((d) => AddStatusColumnData(d, "Received", theme, tm));
        } else {
            return null;
        }
    }, [rawData, theme, tm]);

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, data, theme, isMobile, cf);
        
        generator.TryAddDocumentNumberColumn("oKey", "orderNumber", "Quote", "/quotes", { hideable: false });
        generator.TryAddDateColumn("orderDate", "Date", {});
        generator.TryAddTextColumn("poNumber", "PO Number", {});
        generator.TryAddTextColumn("customerRef", "Customer Ref", {});
        generator.TryAddTotalPriceColumn({});
        generator.TryAddDateColumn("expirationDate", "Expires", {});
        generator.TryAddStatusColumn();
        
        return generator.GetColumns();
    }, [tm, data, theme, isMobile, cf]);

    return <>
        <Grid container direction="row" mt={1} mb={1}>
            <Typography variant="h6" >
                {tm.Get("Submitted Quotes")}
            </Typography>
        </Grid>

        <CustomDataGridPro
            rows={data}
            columns={columns}
            getRowId={getRowId}
            tableName="DashboardSubmittedQuote"
            tableSubName={isMobile ? "Mobile" : ""}
            hideInMobileColumns={[
                "orderDate",
                "poNumber",
                "customerRef",
            ]}
        />
    </>;

};

export default SubmittedQuotesGrid;